module.exports = __webpack_public_path__ + "img/fines-en.655ba70b.svg";